import { render, staticRenderFns } from "./registerEntry_tl11.vue?vue&type=template&id=0b7241cf&scoped=true"
import script from "./registerEntry_tl11.vue?vue&type=script&lang=js"
export * from "./registerEntry_tl11.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/registerEntry_tl11.scss?vue&type=style&index=0&id=0b7241cf&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7241cf",
  null
  
)

export default component.exports